import React from 'react';
import './CustomPagination.css';
import { Dropdown } from 'react-bootstrap';

const CustomPagination = ({
    totalItems,
    totalPages: totalPagesProp,
    rowsPerPage,
    currentPage,
    onPageChange,
    onRowsPerPageChange,
    rowsPerPageOptions = [5, 10, 15, 20, 25, 50]
}) => {
    const parsedTotalItems = Number(totalItems) || 0;
    const parsedTotalPagesProp = totalPagesProp != null ? Number(totalPagesProp) : null;
    const totalPages = parsedTotalPagesProp != null ? parsedTotalPagesProp : Math.ceil(parsedTotalItems / rowsPerPage);

    const start = parsedTotalItems === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
    const end = Math.min(currentPage * rowsPerPage, parsedTotalItems);

    const handlePrevious = () => {
        if (currentPage > 1) {
            onPageChange(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            onPageChange(currentPage + 1);
        }
    };

    const renderPageNumbers = () => {
        const pages = [];
        const gap = "...";

        const renderPageBtn = (i) => (
            <button
                key={i}
                className={`page_number_btn ${currentPage === i ? "active" : ""}`}
                onClick={() => onPageChange(i)}
            >
                {i}
            </button>
        );

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pages.push(renderPageBtn(i));
            }
        } else {
            // First page always shown
            pages.push(renderPageBtn(1));

            if (currentPage <= 3) {
                // Near start: 1 2 3 ... total
                pages.push(renderPageBtn(2));
                pages.push(renderPageBtn(3));
                pages.push(<span key="gap-end" className="pagination_gap">{gap}</span>);
                pages.push(renderPageBtn(totalPages));
            } else if (currentPage >= totalPages - 2) {
                // Near end: 1 ... total-2 total-1 total
                pages.push(<span key="gap-start" className="pagination_gap">{gap}</span>);
                pages.push(renderPageBtn(totalPages - 2));
                pages.push(renderPageBtn(totalPages - 1));
                pages.push(renderPageBtn(totalPages));
            } else {
                // Middle: 1 ... current ... total
                pages.push(<span key="gap-start" className="pagination_gap">{gap}</span>);
                pages.push(renderPageBtn(currentPage));
                pages.push(<span key="gap-end" className="pagination_gap">{gap}</span>);
                pages.push(renderPageBtn(totalPages));
            }
        }
        return pages;
    };

    return (
        <div className="custom_pagination_wrapper">
            <div className="pagination_info">
                Showing {parsedTotalItems === 0 ? 0 : Math.min(rowsPerPage, parsedTotalItems - (currentPage - 1) * rowsPerPage)} from {parsedTotalItems} Data
            </div>

            <div className="pagination_right_side">
                <div className="pagination_controls">
                    <button
                        className="prev_next_btn"
                        onClick={handlePrevious}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <div className="page_numbers">
                        {renderPageNumbers()}
                    </div>
                    <button
                        className="prev_next_btn"
                        onClick={handleNext}
                        disabled={currentPage === totalPages || totalPages === 0}
                    >
                        Next
                    </button>
                </div>

                <div className="rows_per_page_selector">
                    <Dropdown drop="up" onSelect={(val) => onRowsPerPageChange(Number(val))}>
                        <Dropdown.Toggle className="rows_select_toggle">
                            {rowsPerPage}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="rows_dropdown_menu">
                            <div className="rows_dropdown_header">List Size</div>
                            {rowsPerPageOptions.map(option => (
                                <Dropdown.Item
                                    key={option}
                                    eventKey={option}
                                    className={rowsPerPage === option ? 'active' : ''}
                                >
                                    {option}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            </div>
        </div>
    );
};

export default CustomPagination;
